import {useContext, useEffect, useState} from "react";
import {Button, ButtonGroup} from "@mui/material";
import AuthContext from "../Services/AuthContext";
import Main from "../Layout/Main";
import {
    createTableColumn,
    DataGrid,
    DataGridBody,
    DataGridCell,
    DataGridHeader,
    DataGridHeaderCell,
    DataGridRow
} from "@fluentui/react-components";
import {useNavigate, useParams} from "react-router-dom";
import {Add, Upload} from "@mui/icons-material";
import ImportPriority from "../Panel/Season/ImportPriority";
import AddPriority from "../Panel/Season/AddPriority";

function SeasonPriorities() {
    const [user] = useContext(AuthContext);
    const params = useParams();
    const [items, setItems] = useState([]);
    const [season, setSeason] = useState({name: ''});
    const [addPriority, setAddPriority] = useState(false);
    const [importCSV, setImportCSV] = useState(false);
    const [refresh, setRefresh] = useState(0);

    const navigate = useNavigate();
    useEffect(() => {
        if (user.token === "") {
            navigate("/");
        }
    }, [user.token, navigate]);

    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            const url = `/api/season/${params.id}/priority`;
            await fetch(url, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setItems(data.priority);
                    setSeason(data.season);
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, user.token, refresh]);

    const actions = <ButtonGroup>
        <Button variant={'contained'} startIcon={<Add />} onClick={() => setAddPriority(true)}>Dodaj Pesel</Button>
        <Button variant={'contained'} color={'warning'} startIcon={<Upload />} onClick={() => setImportCSV(true)}>Import CSV</Button>
    </ButtonGroup>;

    const columns = [
        createTableColumn ({
            columnId: "personal_id",
            renderHeaderCell: () => {
                return "PESEL";
            },
            renderCell: (item) => {
                return item.personal_id;
            }
        })
    ];

    return (
        <Main title={'Priorytetowe zapisy ' + season.name} actions={actions}>
            <DataGrid
                items={items}
                columns={columns}
                sortable
                getRowId={(item) => item.id}
                focusMode="composite"
                style={{minWidth: "95vw"}}
            >
                <DataGridHeader>
                    <DataGridRow>
                        {({renderHeaderCell}) => (
                            <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                        )}
                    </DataGridRow>
                </DataGridHeader>
                <DataGridBody>
                    {({item, rowId}) => (
                        <DataGridRow key={rowId}>
                            {({renderCell}) => (
                                <DataGridCell>{renderCell(item)}</DataGridCell>
                            )}
                        </DataGridRow>
                    )}
                </DataGridBody>
            </DataGrid>
            <AddPriority isOpen={addPriority} dismiss={() => setAddPriority(false)} onSuccess={() => setRefresh(r => ++r)} />
            <ImportPriority isOpen={importCSV} dismiss={() => setImportCSV(false)} onSuccess={() => setRefresh(r => ++r)} />
        </Main>
    );
}

export default SeasonPriorities;